



















import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { PRODUCT_GALLERY } from '~/constants/productGallery';
import type { Product360Image } from '~/types/product/Product360Image';

export default defineComponent({
  name: 'ThreeSixtyImage',
  props: {
    threeSixtyImage: {
      type: Object as PropType<Product360Image>,
      required: true,
    },
  },
  setup() {
    return { PRODUCT_GALLERY };
  },
});

